import {
  ORDER_EXPENSE_REQUEST_ACTION,
  EXPENSE_REQUEST_ACTION,
} from '../constants/urls';
import zfetch, { METHOD_POST } from '../pages/common/utils/zfetch';

export const orderExpenseRequestAction = payload => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(payload),
  };

  return zfetch(ORDER_EXPENSE_REQUEST_ACTION, options).then(res => res.json());
};

export const expenseRequestAction = payload => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify(payload),
  };

  return zfetch(EXPENSE_REQUEST_ACTION, options).then(res => res.json());
};
